import { DELETE_CART_ITEMS } from 'shared/store/ducks/cart/types.consts'
/**
 * Clear session delete cart item flag on page load
 */
export default () => {
  window.sessionStorage.removeItem(DELETE_CART_ITEMS)
}
